import { useEffect, useState } from 'react';

import type Typo from 'typo-js';

import { getTypoInstance, getTypoInstanceSync } from '@/utils/typo';

export const useTypo = () => {
  const [typo, setTypo] = useState<Typo | null>(getTypoInstanceSync());

  useEffect(() => {
    getTypoInstance()
      .then((instance) => {
        setTypo(instance);
      })
      .catch(() => {});
  }, []);

  return typo;
};
